import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Icon from '@mdi/react';
import { mdiBaseballDiamondOutline } from '@mdi/js';
import { FaRunning, FaUsers, FaReceipt, FaSlidersH, FaGamepad, FaEnvelope } from 'react-icons/fa';
import { FaFutbol } from 'react-icons/fa6';

function LeagueManagerSideBarLeft() {

    useEffect(() => {
        const handleOffcanvasHidden = () => {
            // Simple cleanup - just remove any backdrop that exists
            const backdrop = document.querySelector('.offcanvas-backdrop');
            if (backdrop) {
                backdrop.remove();
            }
            document.body.classList.remove('modal-open');
        };

        // Get the specific offcanvas element
        const offcanvasElement = document.getElementById('offcanvasSideNavbar');

        if (offcanvasElement) {
            // Listen for the hidden event on this specific offcanvas
            offcanvasElement.addEventListener('hidden.bs.offcanvas', handleOffcanvasHidden);

            // Cleanup function
            return () => {
                offcanvasElement.removeEventListener('hidden.bs.offcanvas', handleOffcanvasHidden);
            };
        }
    }, []);

    return (
        <>
            {/* Advanced filter responsive toggler START */}
            {/* <div className="d-flex align-items-center d-lg-none">
                <button
                    className="border-0 bg-transparent"
                    type="button"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#offcanvasSideNavbar"
                    aria-controls="offcanvasSideNavbar"
                >
                    <span className="btn btn-primary">
                        <FaSlidersH />
                    </span>
                    <span className="h6 mb-0 fw-bold d-lg-none ms-2">League Manager</span>
                </button>
            </div> */}
            {/* Advanced filter responsive toggler END */}


            {/* Navbar START */}
            <nav className="navbar navbar-expand-lg mx-0">
                <div className="offcanvas offcanvas-start" tabIndex="-1" id="offcanvasSideNavbar">
                    {/* Offcanvas header */}
                    <div className="offcanvas-header">
                        <button
                            type="button"
                            className="btn-close text-reset ms-auto"
                            data-bs-dismiss="offcanvas"
                            aria-label="Close"
                        ></button>
                    </div>

                    {/* Offcanvas body */}
                    <div className="offcanvas-body d-block px-2 px-lg-0">
                        {/* Card START */}
                        <div className="card overflow-hidden">

                            {/* Card body START */}
                            <div className="card-body">
                                {/* Side Nav START */}
                                <ul className="nav nav-tabs nav-pills nav-pills-soft flex-column fw-bold gap-2 border-0">
                                    <li className="nav-item">
                                        <Link className="nav-link d-flex mb-0" to="/league-manager/">
                                            <Icon className="me-1" path={mdiBaseballDiamondOutline} size={1} />
                                            <span>Leagues</span>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link d-flex mb-0" to="/league-manager/seasons/active">
                                            <FaFutbol className="me-2" size={16} />
                                            <span>Active Seasons</span>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link d-flex mb-0" to="/league-manager/teams/">
                                            <FaUsers className="me-1" size={16} />
                                            <span>Teams</span>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link
                                            to="/league-manager/games/"
                                            className="nav-link d-flex mb-0"
                                        >
                                            <FaGamepad className="me-1" size={16} />
                                            Games
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link
                                            to="/league-manager/players/"
                                            className="nav-link d-flex mb-0"
                                        >
                                            <FaRunning className="me-1" size={16} />
                                            Players
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link
                                            to="/league-manager/orders/"
                                            className="nav-link d-flex mb-0"
                                        >
                                            <FaReceipt className="me-1" size={16} />
                                            Orders
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link
                                            to="/league-manager/campaigns/"
                                            className="nav-link d-flex mb-0"
                                        >
                                            <FaEnvelope className="me-1" size={16} />
                                            Campaigns
                                        </Link>
                                    </li>
                                </ul>
                                {/* Side Nav END */}
                            </div>
                            {/* Card body END */}
                            {/* Card footer */}
                            <div className="card-footer text-center py-2">
                                <a className="btn btn-link btn-sm" href="/profile/">
                                    View Profile
                                </a>
                            </div>
                        </div>
                        {/* Card END */}
                        {/* Helper link END */}
                        <p className="small text-center mt-1">
                            ©{new Date().getFullYear()}{' '}
                            <a className="text-reset" target="_blank" href="/" rel="noreferrer">
                                Lemont Rec Leagues
                            </a>
                        </p>
                    </div>
                </div>
            </nav>
            {/* Navbar END */}
        </>
    );
}

export default LeagueManagerSideBarLeft;
